function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.65118 0.961394L13.497 9.37148C13.6037 9.62251 13.6503 9.82663 13.6637 10.0387C13.6903 10.5341 13.517 11.0157 13.1771 11.3863C12.8371 11.7556 12.3772 11.9736 11.8773 12H2.11894C1.91231 11.9874 1.70568 11.9405 1.51238 11.8679C0.545875 11.4781 0.0792874 10.3815 0.472555 9.43093L5.35173 0.955449C5.51837 0.657519 5.77166 0.400546 6.08494 0.235396C6.99146 -0.26732 8.1446 0.0629796 8.65118 0.961394ZM7.57803 6.5038C7.57803 6.82089 7.31807 7.08579 6.99813 7.08579C6.67818 7.08579 6.41156 6.82089 6.41156 6.5038V4.63496C6.41156 4.31722 6.67818 4.06024 6.99813 4.06024C7.31807 4.06024 7.57803 4.31722 7.57803 4.63496V6.5038ZM6.99813 9.34506C6.67818 9.34506 6.41156 9.08016 6.41156 8.76373C6.41156 8.44599 6.67818 8.18175 6.99813 8.18175C7.31807 8.18175 7.57803 8.44004 7.57803 8.75647C7.57803 9.08016 7.31807 9.34506 6.99813 9.34506Z",
  fill: "#EE4F3A"
});
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.8f3bb66dd9c96a135479fec58a698d46.svg";
export { ForwardRef as ReactComponent };